import Naluri from '~/common/api/naluri';
import {
  FOOD_JOURNAL_GET_JOURNAL_BEGIN,
  FOOD_JOURNAL_GET_JOURNAL_SUCCESS,
  FOOD_JOURNAL_GET_JOURNAL_FAILURE,
  FOOD_JOURNAL_GET_JOURNAL_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getJournal(journalID, userID) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: FOOD_JOURNAL_GET_JOURNAL_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let doRequest;
      if (userID) {
        doRequest = Naluri.get(`/api/expert/dishes/${journalID}?user_id=${userID}`);
      } else {
        doRequest = Naluri.get(`/api/expert/dishes/${journalID}/entry`);
      }

      doRequest.then(
        res => {
          dispatch({
            type: FOOD_JOURNAL_GET_JOURNAL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: FOOD_JOURNAL_GET_JOURNAL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetJournalError() {
  return {
    type: FOOD_JOURNAL_GET_JOURNAL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FOOD_JOURNAL_GET_JOURNAL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        journal: null,
        getJournalPending: true,
        getJournalError: null,
      };

    case FOOD_JOURNAL_GET_JOURNAL_SUCCESS:
      // The request is success
      return {
        ...state,
        journal: action.data,
        getJournalPending: false,
        getJournalError: null,
      };

    case FOOD_JOURNAL_GET_JOURNAL_FAILURE:
      // The request is failed
      return {
        ...state,
        getJournalPending: false,
        getJournalError: action.data.error,
      };

    case FOOD_JOURNAL_GET_JOURNAL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getJournalError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/getJournal.js